import { endpoints } from '_/lib/frontend-utils';
import last from 'lodash/last';

export function formatExtractorUrl(extractorId: string): string {
  return `https://app.${endpoints.rootDomain}/dash/extractors/${extractorId}`;
}

const REDASH_EXTRACTOR_DASHBOARD_ID = 4456;

export function formatRedashExtractorDashboardUrl(extractorId: string, days = '7'): string {
  const params = new URLSearchParams({
    p_days: days,
    p_engine: 'NULL',
    p_extractor_id: extractorId,
    p_w6766_cell: 'null',
    p_w6766_proxy_country: 'NULL',
    p_w6766_proxy_type: 'NULL',
    p_w6766_state: 'NULL',
  });
  return `https://bi.import.io/default/dashboards/${REDASH_EXTRACTOR_DASHBOARD_ID}-extractor-performance?${params.toString()}`;
}

interface LocationParams {
  pathname?: string;
}

export const isNewEntityPage = ({ pathname }: LocationParams): boolean => {
  const path = (pathname && pathname.split('/')) || [];
  return last(path) === '_new';
};
